var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pa-4"},[_c('portal',{attrs:{"to":"app-header"}},[_c('router-link',{staticClass:"ml-2",attrs:{"to":"/tableheadingsticky"}},[_vm._v(" 看看示例 ")])],1),_c('CodeHighlight',{attrs:{"code":_vm.code}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }